<script setup lang="ts">
// import { type MessageSchema } from '@/i18n';
import { useEventBus } from '@/composables/useEventBus';
import { useDishesStore } from '@/stores/dishesStore';
import Skeleton from 'primevue/skeleton';
import { ref } from 'vue';
// import { useI18n } from 'vue-i18n';

// const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
const eventBus = useEventBus();

const props = withDefaults(
  defineProps<{
    title?: string | undefined;
  }>(),
  {
    title: undefined,
  },
);

// const dishesStore = ref(useDishesStore());

const emit = defineEmits<{
  (e: 'generateDishTitle', type: string): void;
}>();

const generationParams = ref(useDishesStore().generationParams);

function generateDish() {
  if (!generationParams.value.dish_title && typeof props.title !== 'string') return;
  generationParams.value.dish_title = props.title;
  const title = props.title || '';
  if (title == '') return;

  // Émet l'événement pour l'onboarding
  console.log('[Onboarding] Clic sur suggestion de recette, émission événement');
  eventBus.emit('onboarding:recipe-suggestion-clicked');

  emit('generateDishTitle', title);
  console.log(generationParams.value);
}
</script>

<template>
  <div
    v-if="title"
    class="recipe-item my-5 flex w-full items-center justify-between gap-2 rounded-lg bg-primary-100 px-6 py-3 shadow-clickable-card"
    @click="generateDish()"
  >
    <p class="font-semibold text-sm">{{ title || '' }}</p>

    <i class="pi pi-angle-right text-lg"></i>
  </div>
  <Skeleton v-else height="42px" class="my-5 w-full bg-primary-300 dark:bg-primary-500" />
  <!-- <GenerationResultCard v-for="dish in data.response" :key="dish.id" :dish @click="dishClicked(dish)" /> -->
</template>

<style scoped>
div:hover {
  cursor: pointer;
}
</style>
